import { Box } from '@mui/material';
import type { FC, ReactNode } from 'react';
import CustomButton from 'src/core/ui/CustomButton';
import HelpOutlineTwoToneIcon from '@mui/icons-material/HelpOutlineTwoTone';

const TooltipField: FC<{ tooltipText?: ReactNode }> = ({ tooltipText }) => {
  return (
    tooltipText ? (
      <Box component="span" sx={{ display: 'inline-flex', ml: 1 }}><CustomButton title="Field help" tooltipText={tooltipText} iconButton size="small" icon={<HelpOutlineTwoToneIcon fontSize="small" />} onClick={() => { }} /></Box>
    ) : <></>
  );
};

export default TooltipField;
